package com.appsyde.shared.modules.ticket.data.repository

import com.appsyde.shared.modules.ticket.data.source.EmailRemoteDataSource
import com.appsyde.shared.modules.ticket.domain.repository.EmailRepository

class EmailRepositoryImpl(
    private val remoteDataSource: EmailRemoteDataSource
) : EmailRepository {

    override suspend fun getUnreadEmailCount() = remoteDataSource.getUnreadEmailsCount()

    override suspend fun getInboxStats() = remoteDataSource.getInboxStats()

    override suspend fun markTicketAsRead(messageId: String) =
        remoteDataSource.markAsRead(messageId)
}
